// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-match__container {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    width: 98%;
}

.tournament-match__info-container {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 16px;
}

.tournament-match__info {
    align-items: center;
    display: flex;
    gap: 8px;
    justify-content: center;
    position: relative;
    width: 33%;
}

.tournament-match__info:first-of-type {
    justify-content: flex-start;
}

.tournament-match__info:last-of-type {
    justify-content: flex-end;
}

.tournament-match__team:first-of-type {
    justify-content: flex-end;
}

.tournament-match__team:last-of-type {
    justify-content: flex-start;
}

.tournament-match__teams-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 8px 0;
    border-top: 1px solid var(--new-background-color);
    border-bottom: 1px solid var(--new-background-color);
}

.tournament-match__team {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 40%;
}

.tournament-match__team .baloa-names {
    font-size: 18px;
    font-weight: 400;
    line-height: 21px;
}

.tournament-match__team-img {
    display: flex;
    align-items: center;
    gap: 12px;
}

.tournament-match__team-img .icon-ball {
    font-size: 30px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 4px;
    height: 38px;
    color: var(--white-color);
}

.tournament-match__team-img img {
    width: 38px;
    height: 38px;
}

.tournament-match__teams-status__container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-direction: column;
    width: 20%;
}

.tournament-match__teams-status__label {
    padding: 4px;
    border-radius: 2px;
}

.tournament-match__teams-status__label.Scheduled {
    background-color: #3078B3; /* TODO new color */
}

.tournament-match__teams-status__label.Not_scheduled {
    background-color: var(--new-yellow-color);
}

.tournament-match__teams-status__label.Finalized {
    background-color: var(--basic-gray-color);
}

.tournament-match__teams-status__label.baloa-username {
    font-size: 13px;
    line-height: 16px;
    color: var(--white-color);
}

.tournament-match__actions-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin: 8px 0;
}
.tournament-match__actions-container.finalized {
    justify-content: space-between;
}

.tournament-match__actions-container .button {
    max-width: 170px;
    font-size: 15px;
    line-height: 17px;
    padding: 8px;
    gap: 8px;
    align-items: center;
    text-wrap: nowrap;
}

.tournament-match__actions-container .secondary-button {
    border: none;
}

.tournament-match__actions-container .icon {
    grid-area: icon;
}

.tournament-match__actions-container .hubicon-edit:before,
.tournament-match__actions-container .hubicon-view_form::before {
    color: unset;
}

.tournament-match__info-edit {
    position: absolute;
    width: 370px;
    box-shadow: var(--shadow-card-1);
    border-radius: 8px;
    background-color: var(--white-color);
    top: 40px;
    left: 0px;
    display: none;
    z-index: 100;
}

.tournament-match__info-edit.show {
    display: block;
}

.tournament-match__info__options {
    position: relative;
}

.tournament-match__info__options .icon-options {
    color: var(--black-color);
    font-size: 16px;
    cursor: pointer;
}

.tournament-match__info__options-box {
    position: absolute;
    padding: 8px;
    box-shadow: var(--shadow);
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-radius: 8px;
    top: 24px;
    background-color: var(--white-color);
    right: 0;
    display: none;
}

.tournament-match__info__options-box .baloa-names {
    padding: 8px;
    color: var(--primary-very-dark-color);
    text-wrap: nowrap;
}

.tournament-match__info__options-box .baloa-names a{
    color: var(--primary-very-dark-color);
    text-wrap: nowrap;
}

.tournament-match__info__options-box .baloa-names:hover {
    background-color: var(--new-background-color);
    border-radius: 8px;
    cursor: pointer;
}

.tournament-match__info__options-box.open {
    display: block;
}

.tournament-match__info__not-scheduled.baloa-table {
    color: var(--new-green-color);
    cursor: pointer;
}

.tournament-match__info__scheduled.baloa-table,
.tournament-match__info__official-referee.baloa-table {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-match/TournamentMatchComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,iDAAiD;IACjD,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB,EAAE,mBAAmB;AAClD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;AACjB;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,oCAAoC;IACpC,SAAS;IACT,SAAS;IACT,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,oCAAoC;IACpC,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB","sourcesContent":[".tournament-match__container {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    width: 98%;\n}\n\n.tournament-match__info-container {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    padding: 16px;\n}\n\n.tournament-match__info {\n    align-items: center;\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    position: relative;\n    width: 33%;\n}\n\n.tournament-match__info:first-of-type {\n    justify-content: flex-start;\n}\n\n.tournament-match__info:last-of-type {\n    justify-content: flex-end;\n}\n\n.tournament-match__team:first-of-type {\n    justify-content: flex-end;\n}\n\n.tournament-match__team:last-of-type {\n    justify-content: flex-start;\n}\n\n.tournament-match__teams-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    padding: 8px 0;\n    border-top: 1px solid var(--new-background-color);\n    border-bottom: 1px solid var(--new-background-color);\n}\n\n.tournament-match__team {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 40%;\n}\n\n.tournament-match__team .baloa-names {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 21px;\n}\n\n.tournament-match__team-img {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.tournament-match__team-img .icon-ball {\n    font-size: 30px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 4px;\n    height: 38px;\n    color: var(--white-color);\n}\n\n.tournament-match__team-img img {\n    width: 38px;\n    height: 38px;\n}\n\n.tournament-match__teams-status__container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    flex-direction: column;\n    width: 20%;\n}\n\n.tournament-match__teams-status__label {\n    padding: 4px;\n    border-radius: 2px;\n}\n\n.tournament-match__teams-status__label.Scheduled {\n    background-color: #3078B3; /* TODO new color */\n}\n\n.tournament-match__teams-status__label.Not_scheduled {\n    background-color: var(--new-yellow-color);\n}\n\n.tournament-match__teams-status__label.Finalized {\n    background-color: var(--basic-gray-color);\n}\n\n.tournament-match__teams-status__label.baloa-username {\n    font-size: 13px;\n    line-height: 16px;\n    color: var(--white-color);\n}\n\n.tournament-match__actions-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    margin: 8px 0;\n}\n.tournament-match__actions-container.finalized {\n    justify-content: space-between;\n}\n\n.tournament-match__actions-container .button {\n    max-width: 170px;\n    font-size: 15px;\n    line-height: 17px;\n    padding: 8px;\n    gap: 8px;\n    align-items: center;\n    text-wrap: nowrap;\n}\n\n.tournament-match__actions-container .secondary-button {\n    border: none;\n}\n\n.tournament-match__actions-container .icon {\n    grid-area: icon;\n}\n\n.tournament-match__actions-container .hubicon-edit:before,\n.tournament-match__actions-container .hubicon-view_form::before {\n    color: unset;\n}\n\n.tournament-match__info-edit {\n    position: absolute;\n    width: 370px;\n    box-shadow: var(--shadow-card-1);\n    border-radius: 8px;\n    background-color: var(--white-color);\n    top: 40px;\n    left: 0px;\n    display: none;\n    z-index: 100;\n}\n\n.tournament-match__info-edit.show {\n    display: block;\n}\n\n.tournament-match__info__options {\n    position: relative;\n}\n\n.tournament-match__info__options .icon-options {\n    color: var(--black-color);\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.tournament-match__info__options-box {\n    position: absolute;\n    padding: 8px;\n    box-shadow: var(--shadow);\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    border-radius: 8px;\n    top: 24px;\n    background-color: var(--white-color);\n    right: 0;\n    display: none;\n}\n\n.tournament-match__info__options-box .baloa-names {\n    padding: 8px;\n    color: var(--primary-very-dark-color);\n    text-wrap: nowrap;\n}\n\n.tournament-match__info__options-box .baloa-names a{\n    color: var(--primary-very-dark-color);\n    text-wrap: nowrap;\n}\n\n.tournament-match__info__options-box .baloa-names:hover {\n    background-color: var(--new-background-color);\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.tournament-match__info__options-box.open {\n    display: block;\n}\n\n.tournament-match__info__not-scheduled.baloa-table {\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.tournament-match__info__scheduled.baloa-table,\n.tournament-match__info__official-referee.baloa-table {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
